import { unreachableCaseError } from "@edgetier/utilities";
import { SearchType } from "@edgetier/watchtower-types";

/**
 * Get the appropriate name for the different search types.
 * @param searchType The search type who's name we're getting.
 * @returns A string which is the name of the search type.
 */
export const getSearchTypeName = (searchType: SearchType) => {
    switch (searchType) {
        case SearchType.Query:
            return "query";
        case SearchType.Similarity:
            return "similarity";
        case SearchType.Regex:
            return "regex";
        default:
            throw unreachableCaseError(searchType);
    }
};
